import { render, staticRenderFns } from "./itemDetail.vue?vue&type=template&id=7454b586&"
import script from "./itemDetail.vue?vue&type=script&lang=ts&"
export * from "./itemDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "itemDetail.vue"
export default component.exports